import AiSummaries from './AiSummaries';

export default AiSummaries;
